import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';

import statementsClient from '@clients/statementsClient';
import StatementsPanel from '@components/overviewPanels/statementPanel/StatementsPanel';
import { AccountStatusPanelItemData } from '@components/overviewPanels/statementPanel/StatementsPanelItem';
import { useAccount } from '@contexts/AccountProvider';
import notifyAPIError from '@utils/notifyAPIError';

const { getStatements } = statementsClient();
const StatementsPanelContainer = () => {
    const { accountId } = useParams();
    const navigate = useNavigate();

    const {
        data: statements,
        isError: statementsIsError,
        isLoading: statementsLoading,
    } = useQuery(
        ['overviewStatementDetails', accountId],
        () => getStatements({ accountId: accountId, perPage: 3 }),
        {
            onError: notifyAPIError,
        },
    );

    const { program, isLoading: isLoadingAccounts } = useAccount();

    const handleOnClick = () => {
        navigate(`/${accountId}/statements`);
    };

    const NO_OF_ITEMS_TO_DISPLAY = 3;

    const panels: AccountStatusPanelItemData[] = statements?.items
        ?.map((statementItem) => {
            return {
                statementId: statementItem?.statement_id?.toString(),
                date: statementItem.calendar?.cycle_closing_date,
                amountTotal: statementItem.current_balance,
                currencyCode: program?.currency_numeric_code,
                isPaid: statementItem.current_balance == 0,
            };
        })
        .filter((statementItem, i) => i < NO_OF_ITEMS_TO_DISPLAY);

    return (
        <StatementsPanel
            isLoading={statementsLoading || isLoadingAccounts}
            onClick={handleOnClick}
            panels={panels}
            isError={statementsIsError}
        />
    );
};

export default StatementsPanelContainer;
